export const LOAD_VERSIONS = 'bible/LOAD_VERSIONS';
export const LOAD_VERSION = 'bible/LOAD_VERSION';
export const LOAD_CHAPTER = 'bible/LOAD_CHAPTER';
export const SELECT_VERSION = 'bible/SELECT_VERSION';
